import { ref } from 'vue';
import type { FacilityGroupID, FacilityID, TenantID, UserID } from '../cross-app-shared/types/db.ts';
import type { Email, Uid } from '../cross-app-shared/types/common';
import { crossAppActions } from './cross-app-actions.ts';

export const you = ref<{
  userID: UserID;
  firebaseUid: Uid;
  name: string;
  email: string;
  primaryTenantID: TenantID | null;
  primaryFacilityGroupID: FacilityGroupID | null;
  primaryFacilityID: FacilityID | null;
}>({
  userID: -1 as UserID,
  firebaseUid: 'INVALID UID' as Uid,
  name: 'Unknown User',
  email: 'unknown@example.com' as Email,
  primaryTenantID: null,
  primaryFacilityGroupID: null,
  primaryFacilityID: null,
});

export async function youRefresh() {
  return await crossAppActions.users
    .you()
    .catch(() => ({
      userID: -1 as UserID,
      firebaseUid: 'INVALID UID' as Uid,
      name: 'Unknown User',
      email: 'unknown@example.com' as Email,
      primaryTenantID: null,
      primaryFacilityGroupID: null,
      primaryFacilityID: null,
    }))
    .then((response) => {
      you.value = response;
      return response;
    });
}
